import React from "react";
// Components
import PatientData from "~/components/common/Patient/PatientData";
import PatientControlPanel from "~/components/common/Patient/PatientControlPanel";
// Styles
import s from "./UserInformation.module.scss";

interface Props {}

const UserInformation: React.FC<Props> = ({}) => {
  return (
    <div className={s.layoutUserInformation}>
      <div className={s.userDataContainer}>
        <div className={s.userDataHeading}>
          <h1 className="headline-1">Онлайн запись на прием к врачу</h1>
        </div>
        <div className={s.userDataItself}>
          <PatientData />
        </div>
        <div className={s.userDataControls}>
          <PatientControlPanel />
        </div>
      </div>
    </div>
  );
};

export default UserInformation;
